import { Component, Input } from '@angular/core';

@Component({
  selector: 'axis-media',
  templateUrl: './media.component.html'
})
export class MediaComponent {
  @Input() separator = false;
  @Input() alignment: string;
  @Input() gutter: string;
}

@Component({
  selector: 'axis-media-left',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-media-left'
  }
})
export class MediaLeftComponent {}

@Component({
  selector: 'axis-media-body',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-media-body'
  }
})
export class MediaBodyComponent {}

@Component({
  selector: 'axis-media-right',
  template: '<ng-content></ng-content>',
  host: {
    class: 'axis-media-right'
  }
})
export class MediaRightComponent {}
